import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {Me} from '../../../../Models/Me';
import {FullWorkout} from '../../../../Models/FullWorkout';
import {PresenterProps, withPresenter} from '../../../../Support/with_presenter';
import {UploadToStravaPresenter} from './UploadToStravaPresenter';
import {classNames} from '../../../Support/classNames';

interface OwnProps {
    me: Me;
    fullWorkout: FullWorkout;
    className?: string;
}

const UploadToStravaComponent: FunctionComponent<OwnProps & PresenterProps<UploadToStravaPresenter>> = observer(
    ({presenter, className, me, fullWorkout}) => {
        if (me.id !== fullWorkout.user_id) {
            return null;
        }
        if (presenter.syncedToStrava) {
            return (
                <div className={classNames('card', className)}>
                    <div className="card-title">
                        <h5>Upload to Strava</h5>
                    </div>
                    <div className="card-body">
                        <p>This workout was synced to Strava</p>
                    </div>
                </div>
            );
        }

        if (!me.stravaConnected) {
            return (
                <div className={classNames('card', className)}>
                    <div className="card-title">
                        <h5>Upload to Strava</h5>
                    </div>
                    <div className="card-body">
                        <p>To sync this workout with Strava, connect your account</p>
                        <a className="btn btn-strava btn-wide" href="/account">
                            Connect
                        </a>
                    </div>
                </div>
            );
        }

        if (presenter.uploading) {
            return (
                <div className={classNames('card', className)}>
                    <div className="card-title">
                        <h5>Strava</h5>
                    </div>
                    <div className="card-body">
                        <p>Sync this workout with one click to your Strava profile</p>
                        <button className="btn btn-strava btn-wide">
                            <div className="spinner-border spinner-border-sm text-light" role="status"></div>
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div className={classNames('card', className)}>
                <div className="card-title">
                    <h5>Strava</h5>
                </div>
                <div className="card-body">
                    <p>Sync this workout with one click to your Strava profile</p>
                    <button className="btn btn-strava btn-wide" onClick={() => presenter.uploadToStrava()}>
                        Sync
                    </button>
                </div>
            </div>
        );
    },
);

export const UploadToStrava = withPresenter<UploadToStravaPresenter, OwnProps>(
    (props, component) => new UploadToStravaPresenter(props.fullWorkout, component.network.workouts),
    UploadToStravaComponent,
);
